<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [resizable]="false"
  [draggable]="true"
  header="Choisir une date pour l'itinéraire"
  [style]="{ width: '400px' }"
  (onHide)="hide()"
>
  <div class="date-selector-content p-3">
    <p>
      Sélectionnez une date entre le
      {{ visibleStartDate | date: 'dd/MM/yyyy' }} et le
      {{ visibleEndDate | date: 'dd/MM/yyyy' }}
      pour voir l'itinéraire journalier de
      <strong>{{ technician?.firstname }} {{ technician?.lastname }}</strong
      >.
    </p>

    <p-datepicker
      [(ngModel)]="selectedDate"
      (ngModelChange)="onDateChange($event)"
      [inline]="true"
      [dateFormat]="'dd/mm/yy'"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [showButtonBar]="true"
      [todayButtonStyleClass]="'p-button-secondary'"
      [clearButtonStyleClass]="'p-button-secondary'"
    ></p-datepicker>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-between">
      <button
        pButton
        label="Annuler"
        icon="pi pi-times"
        class="p-button-text"
        (click)="hide()"
      ></button>
      <button
        pButton
        label="Voir l'itinéraire"
        icon="pi pi-map"
        (click)="onGenerateRoute()"
        [disabled]="!selectedDate"
      ></button>
    </div>
  </ng-template>
</p-dialog>
